import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const {
  ADMIN_BG_COLOR,
  ADMIN_TEXT_COLOR,
  STATUS_PARENT_BG_COLOR,
  STATUS_PARENT_HOVER_BG_COLOR,
  BASE_FONT_FAMILY,
  PLACEHOLDER_COLOR,
  DISABLED_COLOR,
  DISABLED_BG_COLOR,
  DROP_BG_COLOR,
  DROP_ITEM_BG_COLOR,
  DROP_ITEM_HOVER,
  DROP_BORDER_COLOR,
  DROP_ITEM_TEXT_SELECTED_COLOR,
  DROP_ITEM_TEXT_COLOR,
  DROP_ITEM_BORDER_COLOR
} = constants;

let styles = {
  base: {
    display: 'flex',
    height: 'inherit',
    backgroundColor: ADMIN_BG_COLOR,
    color: ADMIN_TEXT_COLOR,
    paddingTop: 10
  },
  flex: {
    display: 'flex'
  },
  content: {
    paddingTop: 50
  },
  cards: {
    backgroundColor: STATUS_PARENT_BG_COLOR,
    height: 150,
    width: '33%',
    borderRadius: 8,
    paddingTop: 0,
    overflow: 'hidden',
    textDecoration: 'none',
    color: ADMIN_TEXT_COLOR,
    margin: 10,
    ':hover': {
      backgroundColor: STATUS_PARENT_HOVER_BG_COLOR
    }
  },
  cardsAp: {
    marginLeft: 30,
    marginRight: 30
  },
  cardGateway: {
    marginLeft: 0
  },
  cardsRp: {
    marginLeft: 30,
    marginRight: 0
  },
  field: {
    display: 'flex',
    width: '100%'
  },
  title: {
    paddingLeft: 10,
    width: '100%',
    fontSize: 18,
    fontWeight: 300,
    flex: 'auto'
  },
  count: {
    paddingTop: 20,
    paddingLeft: 90,
    flex: 'auto',
    width: '35%'
  },
  red: {
    height: 5,
    width: 5,
    backgroundColor: 'rgb(120, 224, 139)',
    borderRadius: '50%'
  },
  field2: {
    flexDirection: 'column',
    display: 'flex'
  },
  auto: {
    flex: 'auto',
    width: '11%'
  },
  position: {
    position: 'absolute',
    right: '2.99%',
    top: 23
  },
  "site-select":{
    width: 200,
    height: 35
  },
  dropDown: {
    position: 'absolute',
    right: '10%',
    top: 23,
    fontSize: '1em',
    fontFamily: BASE_FONT_FAMILY,
    width: '14% !important',
    backgroundColor: DROP_BG_COLOR,
    border: `1px solid ${DROP_ITEM_BORDER_COLOR}`,
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    color: 'WHITE',
    borderRadius: 0,
    ':hover': {
      border: `1px solid ${DROP_ITEM_BORDER_COLOR}`,
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      borderRadius: 0,
      backgroundColor: DROP_BG_COLOR
    },
    '.ui-dropdown .ui-placeholder': {
      color: PLACEHOLDER_COLOR
    },
    '.ui-dropdown .ui-dropdown-trigger': {
      border: 'none',
      lineHeight: '40px',
      width: '30px',
      fontSize: '16px',
      color: DROP_ITEM_BORDER_COLOR
    },
    '.ui-dropdown .ui-dropdown-label': {
      height: '40px',
      padding: 12,
      paddingRight: 36,
      boxSizing: 'border-box',
      whiteSpace: 'nowrap'
    },
    '.ui-dropdown .ui-dropdown-panel': {
      border: `1px solid ${DROP_BORDER_COLOR}`,
      background: 'white',
      marginTop: -2,
      borderRadius: '0 0 4px 4px',
      paddingLeft: 0,
      paddingRight: 0
    },
    ' .ui-dropdown-panel .ui-dropdown-items': {
      padding: 0,
      fontFamily: BASE_FONT_FAMILY
    },
    ' .ui-dropdown-panel .ui-dropdown-item': {
      textTransform: 'capitalize',
      backgroundColor: DROP_ITEM_BG_COLOR,
      color: DROP_ITEM_TEXT_COLOR,
      padding: '10px 10px',
      margin: 0,
      ':hover': {
        backgroundColor: DROP_ITEM_HOVER,
        color: DROP_ITEM_TEXT_SELECTED_COLOR
      }
    },
    '.ui-dropdown.ui-state-disabled': {
      opacity: 1
    },
    '.ui-dropdown.ui-state-disabled .ui-dropdown-label': {
      backgroundColor: DISABLED_BG_COLOR,
      color: DISABLED_COLOR
    },
    ' .ui-dropdown.ui-state-disabled .ui-dropdown-trigger': {
      backgroundColor: DISABLED_BG_COLOR,
      color: DISABLED_COLOR
    },
    ' .ui-inputtext': {
      backgroundColor: DROP_BG_COLOR,
      color: DROP_ITEM_TEXT_SELECTED_COLOR
    },
    '.ui-state-default': {
      backgroundColor: DROP_BG_COLOR
    },
    '.ui-dropdown .ui-dropdown-panel ': {
      borderRadius: 0
    },
    '.ui-dropdown:not(.ui-state-disabled):hover': {
      backgroundColor: DROP_BG_COLOR
    },
    ' .ui-dropdown-panel .ui-dropdown-item:not(.ui-state-highlight):hover': {
      backgroundColor: DROP_ITEM_HOVER,
      borderRadius: 0
    },
    ' .fa': {
      color: `${DROP_ITEM_BORDER_COLOR}`
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/adminstatus/AdminStatus.styles.js